var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 9.58569L22.4143 3.99988C22.2285 3.81415 22.0081 3.66683 21.7654 3.56631C21.5228 3.4658 21.2627 3.41406 21 3.41406C20.7374 3.41406 20.4773 3.4658 20.2347 3.56631C19.992 3.66683 19.7715 3.81415 19.5858 3.99988L16.2931 7.2926L16.2929 7.29278L16.2927 7.29297L4.58588 18.9998C4.39956 19.1851 4.25184 19.4055 4.15127 19.6482C4.0507 19.891 3.99929 20.1513 4.00001 20.4141V25.9999C4.00061 26.5301 4.21152 27.0385 4.58646 27.4134C4.96141 27.7884 5.46976 27.9993 6.00001 27.9999H11.5858C11.8486 28.0006 12.1089 27.9492 12.3516 27.8486C12.5943 27.7481 12.8147 27.6004 13 27.4141L28.0001 12.4141C28.3746 12.0387 28.5849 11.5301 28.5849 10.9999C28.5848 10.4696 28.3745 9.96105 28 9.58569ZM24 13.5857L18.4142 7.99988L21 5.41406L26.5858 10.9999L24 13.5857Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilBlack);
export default __webpack_public_path__ + "static/media/pencil-black.364b99aa1d20f58c3a2e70ed9c3f0488.svg";
export { ForwardRef as ReactComponent };